import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import { DfpComponent } from "../../ads/dfp-component";
import ReadEmagazineBlack from "../ReadEmagazineBlack";
import "./newsletter.m.css";

export const Newsletter = ({ collection, config, magazineWidget }) => {
  const networkId = get(config, ["ads-config", "network_id"], {});
  const associatedMetadata = get(collection, ["associated-metadata"], {});
  const [adComponent, setAdComponent] = useState();
  useEffect(() => {
    setAdComponent(
      <>
        <BrowserView>
          {associatedMetadata.desktop_component_ad_unit && (
            <DfpComponent
              id={`newsletter-ad-${collection.id}`}
              path={`/${networkId}/${associatedMetadata.desktop_component_ad_unit}`}
              adSlotConfigName="mRec_ad"
              showText={false}
              adStyleName="ad-style-300x250"
            />
          )}
        </BrowserView>
        <MobileView>
          {associatedMetadata.mobile_component_ad_unit && (
            <DfpComponent
              id={`newsletter-ad-mobile-${collection.id}`}
              path={`/${networkId}/${associatedMetadata.mobile_component_ad_unit}`}
              adSlotConfigName="mRec_ad"
              showText={false}
              adStyleName="ad-style-300x250"
            />
          )}
        </MobileView>
      </>
    );
  }, []);

  return (
    <div className="newsletter-container" styleName="newsletter-container">
      <div styleName="ad-wrapper-newsletter">{adComponent}</div>
      <div styleName="newsletter">
        <ReadEmagazineBlack magazineWidget={magazineWidget} />
      </div>
    </div>
  );
};
